import * as managers from 'app/mocks/data/park/managers/list'

import { StatusReport } from 'app/types/reports'
import { SaleReport } from 'app/types/reports/sale'

export const saleReport1: SaleReport = {
    id: 1,
    creation_datetime: '2025-01-01T00:00:00',
    manager: managers.manager1,
    date_start: '2024-12-28',
    date_end: '2024-12-31',
    status: StatusReport.enum.DONE,
}

export const saleReport2: SaleReport = {
    id: 2,
    creation_datetime: '2025-01-01T01:00:00',
    manager: managers.manager1,
    date_start: '2024-12-01',
    date_end: '2025-01-01',
    status: StatusReport.enum.DONE,
}

export const saleReport3: SaleReport = {
    id: 3,
    creation_datetime: '2025-01-02T00:00:00',
    manager: managers.manager2,
    date_start: '2024-12-01',
    date_end: '2024-12-31',
    status: StatusReport.enum.DONE,
}

export const saleReport4: SaleReport = {
    id: 4,
    creation_datetime: '2025-01-02T01:00:00',
    manager: managers.manager1,
    date_start: '2024-11-01',
    date_end: '2025-01-02',
    status: StatusReport.enum.DONE,
}

export const saleReport5: SaleReport = {
    id: 5,
    creation_datetime: '2025-01-02T02:00:00',
    manager: managers.manager1,
    date_start: '2024-12-04',
    date_end: '2025-01-02',
    status: StatusReport.enum.DONE,
}

export const saleReport6: SaleReport = {
    id: 6,
    creation_datetime: '2025-01-07T00:00:00',
    manager: managers.manager2,
    date_start: '2024-09-18',
    date_end: '2024-12-09',
    status: StatusReport.enum.DONE,
}

export const saleReport7: SaleReport = {
    id: 7,
    creation_datetime: '2025-01-07T01:00:00',
    manager: managers.manager3,
    date_start: '2024-09-30',
    date_end: '2024-10-19',
    status: StatusReport.enum.DONE,
}

export const saleReport8: SaleReport = {
    id: 8,
    creation_datetime: '2025-01-08T00:00:00',
    manager: managers.manager4,
    date_start: '2024-10-30',
    date_end: '2024-12-19',
    status: StatusReport.enum.DONE,
}

export const saleReport9: SaleReport = {
    id: 9,
    creation_datetime: '2025-01-09T00:00:00',
    manager: managers.manager4,
    date_start: '2024-08-26',
    date_end: '2024-11-11',
    status: StatusReport.enum.DONE,
}

export const saleReport10: SaleReport = {
    id: 10,
    creation_datetime: '2025-01-10T00:00:00',
    manager: managers.manager4,
    date_start: '2024-08-24',
    date_end: '2024-10-17',
    status: StatusReport.enum.DONE,
}

export const saleReport11: SaleReport = {
    id: 11,
    creation_datetime: '2025-01-11T00:00:00',
    manager: managers.manager8,
    date_start: '2024-12-03',
    date_end: '2025-01-05',
    status: StatusReport.enum.DONE,
}

export const saleReport12: SaleReport = {
    id: 12,
    creation_datetime: '2025-01-12T00:00:00',
    manager: managers.manager6,
    date_start: '2024-10-19',
    date_end: '2024-11-21',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport13: SaleReport = {
    id: 13,
    creation_datetime: '2025-01-12T01:00:00',
    manager: managers.manager1,
    date_start: '2024-10-23',
    date_end: '2024-12-30',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport14: SaleReport = {
    id: 14,
    creation_datetime: '2025-01-13T00:00:00',
    manager: managers.manager4,
    date_start: '2024-09-11',
    date_end: '2024-10-31',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport15: SaleReport = {
    id: 15,
    creation_datetime: '2025-01-13T01:00:00',
    manager: managers.manager8,
    date_start: '2024-10-18',
    date_end: '2024-11-14',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport16: SaleReport = {
    id: 16,
    creation_datetime: '2025-01-14T00:00:00',
    manager: managers.manager11,
    date_start: '2024-11-11',
    date_end: '2024-11-16',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport17: SaleReport = {
    id: 17,
    creation_datetime: '2025-01-15T00:00:00',
    manager: managers.manager2,
    date_start: '2024-09-11',
    date_end: '2024-10-11',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport18: SaleReport = {
    id: 18,
    creation_datetime: '2025-01-16T00:00:00',
    manager: managers.manager3,
    date_start: '2024-08-24',
    date_end: '2024-11-20',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport19: SaleReport = {
    id: 19,
    creation_datetime: '2025-01-17T00:00:00',
    manager: managers.manager4,
    date_start: '2024-11-25',
    date_end: '2024-12-09',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport20: SaleReport = {
    id: 20,
    creation_datetime: '2025-01-18T00:00:00',
    manager: managers.manager2,
    date_start: '2024-09-20',
    date_end: '2024-10-18',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport21: SaleReport = {
    id: 21,
    creation_datetime: '2025-01-19T00:00:00',
    manager: managers.manager1,
    date_start: '2024-10-19',
    date_end: '2024-11-03',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport22: SaleReport = {
    id: 22,
    creation_datetime: '2025-01-19T00:00:00',
    manager: managers.manager12,
    date_start: '2024-07-30',
    date_end: '2024-10-29',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport23: SaleReport = {
    id: 23,
    creation_datetime: '2025-01-20T00:00:00',
    manager: managers.manager13,
    date_start: '2024-12-17',
    date_end: '2024-12-26',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport24: SaleReport = {
    id: 24,
    creation_datetime: '2025-01-21T00:00:00',
    manager: managers.manager2,
    date_start: '2024-08-15',
    date_end: '2024-11-18',
    status: StatusReport.enum.IN_PROGRESS,
}

export const saleReport25: SaleReport = {
    id: 25,
    creation_datetime: '2025-01-22T00:00:00',
    manager: managers.manager1,
    date_start: '2024-10-02',
    date_end: '2025-01-10',
    status: StatusReport.enum.IN_PROGRESS,
}
